export class StreetTypeModel {
  name: string;
  code: string;
  id: string;
  version: string
}
